import { DecoratedFormProps, getFormValues, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { useEffect, useState } from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import history from 'src/navigation/history';
import classNames from 'classnames';
import ProgramBookSession from './ProgramBookSession';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { useDispatch } from 'react-redux';
import styles from './assets/seances-form.module.scss';

import {
    faSave,
    faFileSignature,
    faChevronDown,
    faChevronUp,
    faCopy,
    faTrash,
    faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    asyncPersistSeance,
    signSeance,
    updateSeanceNote,
    updateSeanceLocation,
    getCopySeance,
} from 'src/store/actions/seance-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { DropZoneField } from 'src/components/DropZoneField';
import { FieldTextArea } from 'src/components/redux-form/fields/FieldTextArea';
import { FieldDate } from '../../../../../../../../../../components/redux-form/fields/FieldDate';
import Loader from 'src/components/Loader';
import { useSelector } from 'react-redux';
import { copySeanceNoteSelector, miniLoaderForSelector } from 'src/store/selectors/seance-selectors';
import ModalComponent from '../ModalComponent';
import { FieldDropdown } from '../../../../../../../../../../components/redux-form/fields/FieldDropdown';
import { Paginated } from '../../../../../../../../../../services/api-handlers/pagination';
import { IServiceType } from '../../../../../../../../../../types/service-types';
import { IServiceLocation } from '../../../../../../../../../../types/service-locations';

import CaseEnum from '../../../../../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../../../../../components/redux-form/utils/dropdown-values';
import ModalDelete from '../../../../../../../../../../components/calendars/ModalDelete';
import { ISeance } from '../../../../../../../../../../types/seance';
import { Accordion, Card } from 'react-bootstrap';
import { changeToZeroMoment, changeToZeroMomentToDate } from '../../../../../../../../../../helpers/timeHelpers';
import Router from '../../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../../navigation';
import user from '../../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../../enumerables/user-role';

export interface SeanceFormData {
    id?: string | number;
    occasion?: string | number;
    seanceDate?: any;
    startTime?: any;
    startTimeOld?: Date | undefined;
    endTimeOld?: Date | undefined;
    isHome?: boolean;
    detailPage?: boolean;
    isTelehealth?: boolean;
    isSchool?: boolean;
    isInPerson?: boolean;
    serviceType?: any;
    serviceLocation?: any;
    endTime?: any;
    minPerUnit?: any;
    isWeekly?: boolean;
    goals?: string;
    seanceInfo?: string;
    problem?: string;
    attendance?: string;
    eventInfo?: string;
    plan?: string;
    hasPaid?: boolean;
    student: {
        id: any;
    };
}

interface SeanceFormProps {
    files: any;
    dataSheetFiles: any;
    idProvider: string;
    caseType?: string | number;
    isDatasheetRequired?: boolean;
    isDataSheetWait?: boolean;
    serviceTypes: Paginated<IServiceType>;
    serviceLocations: Paginated<IServiceLocation>;
    signDoc: any;
    seances: Paginated<ISeance>;
    setSignDoc: (it: any) => void;
    valuesForm: Partial<ISeance>;
    pgValuesForm: any;
    setLoader: (it: boolean) => void;
    setFiles: (it: [], isDatasheet: boolean) => void;
    removeFile: (it: any) => void;
    getSessionsData: () => void;
    programBookAnswers?: any;
    inProgressAnswers?: boolean;
}

type InjectedProps = InjectedFormProps<SeanceFormData, SeanceFormProps>;

const validators: Validators<SeanceFormData> = {
    goals: [required({ message: 'Goals is required.' })],
    attendance: [required({ message: 'Attendance is required.' })],
    serviceType: [maxLength({ max: 255 })],
    serviceLocation: [maxLength({ max: 255 })],
    minPerUnit: [maxLength({ max: 255 })],
    plan: [required({ message: 'Plan is required.' })],
    problem: [required({ message: 'Challenging Behavior is required.' })],
};

const SeanceForm: React.FunctionComponent<InjectedProps & SeanceFormProps> = ({
    handleSubmit,
    error,
    dirty,
    files,
    dataSheetFiles,
    setLoader,
    caseType,
    setFiles,
    serviceTypes,
    seances,
    serviceLocations,
    removeFile,
    valuesForm,
    pgValuesForm,
    isDataSheetWait,
    isDatasheetRequired,
    idProvider,
    submitting,
    initialValues,
    getSessionsData,
    change,
    programBookAnswers,
    inProgressAnswers,
    form,
}: InjectedProps & SeanceFormProps) => {
    const [popup, setPopup] = useState<boolean>(false);
    const [backModal, setBackModal] = useState<boolean>(false);
    const [isDropZoneLoad, setIsDropZoneLoad] = useState<boolean>(false);
    const [fileItD, setFileItD] = useState<any>(null);
    const [isChangedProgramBook, setIsChangedProgramBook] = useState<boolean>(false);

    const [currentAction, setCurrentAction] = useState<string>('SIGN');
    const [deleteModal, setDeleteModal] = useState<boolean | string>(false);
    const [currentActionData, setCurrentActionData] = useState<any>({});
    const [serviceLocationStatus, setServiceLocationStatus] = useState('start');
    const updateServiceLocationStatus = (status: string) => {
        setServiceLocationStatus(status);
    };
    const isNew = !initialValues || !initialValues.id;
    const status = valuesForm?.status && valuesForm?.status;
    const miniLoaderFor = useSelector(miniLoaderForSelector);
    const dispatch = useDispatch();
    let seanceFuture = false;

    const time = initialValues.endTime ? new Date(initialValues.endTime).getTime() : 0;
    const timeNow = new Date().getTime();
    if (time > timeNow) {
        seanceFuture = true;
    }

    const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
    const isSupervisor = user.getSupervisor();
    const isJustProvider = isProvider && !isSupervisor;
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
    const isNotAllowChangeDate = !isAdmin && initialValues?.hasPaid;

    const copySeance = useSelector(copySeanceNoteSelector);
    const formValues: any = useSelector((state) => getFormValues('seance-form')(state));

    useEffect(() => {
        if (copySeance) {
            if (copySeance.attendance) {
                dispatch(
                    change(
                        'attendance',
                        formValues['attendance']
                            ? formValues['attendance'] + ' ' + copySeance.attendance
                            : copySeance.attendance,
                    ),
                );
            }
            if (copySeance.problem) {
                dispatch(
                    change(
                        'problem',
                        formValues['problem'] ? formValues['problem'] + ' ' + copySeance.problem : copySeance.problem,
                    ),
                );
            }
            if (copySeance.goals) {
                dispatch(
                    change(
                        'goals',
                        formValues['goals'] ? formValues['goals'] + ' ' + copySeance.goals : copySeance.goals,
                    ),
                );
            }
            if (copySeance.plan) {
                dispatch(
                    change('plan', formValues['plan'] ? formValues['plan'] + ' ' + copySeance.plan : copySeance.plan),
                );
            }
        }
    }, [copySeance]);

    const entityModal: any = {
        DATASHEET_DONE: {
            action: () => {
                /*handleSubmit(currentActionData);
                 setCurrentAction('SIGN');
                 setCurrentActionData({});
                 setPopup(false);
                 */
                /*if (programBookAnswers?.data?.list?.length || isChangedProgramBook) {
                    setCurrentAction('PROGRAMBOOK_DONE');
                    // setCurrentActionData({});
                    setPopup(true);
                } else {
                    setCurrentAction('PROGRAMBOOK_WAIT');
                    setPopup(true);
                }*/
            },
            body: <div>Are you sure you want to save the Session Note? </div>,
        },
        DATASHEET_WAIT: {
            action: () => {
                //dispatch(submit('seance-form'));
                //setCurrentAction('SIGN');
                // setCurrentAc=tionData({});
                // setPopup(false);
                // let hasAnswerPB = false;
                // if (programBookAnswers?.data?.list?.length) {
                //     programBookAnswers?.data?.list?.map((item: any) => {
                //         hasAnswerPB = !item.isSkip;
                //         if (hasAnswerPB) {
                //             return true;
                //         }
                //     });
                // }
                //
                // if (hasAnswerPB) {
                //     setCurrentAction('PROGRAMBOOK_DONE');
                //     // setCurrentActionData({});
                //     setPopup(true);
                // } else {
                //     setCurrentAction('PROGRAMBOOK_WAIT');
                //     setPopup(true);
                // }
            },
            body: (
                <div>
                    {`You haven't uploaded Data sheet document, although this case requires it. Are you sure you want to
                    save the Session Note without this document?`}
                </div>
            ),
        },
        PROGRAMBOOK_DONE: {
            action: () => {
                handleSubmit(currentActionData);
                setCurrentAction('SIGN');
                setCurrentActionData({});
                setPopup(false);
            },
            title: 'Please double check the data below: ',
            body: (
                <div>
                    <div>
                        <p>
                            Service Location:{' '}
                            <b>
                                {!valuesForm?.isHome &&
                                !valuesForm?.isInPerson &&
                                !valuesForm?.isTelehealth &&
                                !valuesForm?.isSchool
                                    ? initialValues.serviceLocation?.label + '; '
                                    : ''}
                            </b>
                            <span>
                                <b>{valuesForm?.isHome && 'Home - In person;'}</b>{' '}
                                <b>{valuesForm?.isInPerson && 'School - In person;'}</b>{' '}
                                <b>{valuesForm?.isTelehealth && 'Home - Telehealth;'}</b>{' '}
                                <b>{valuesForm?.isSchool && 'School - Telehealth;'}</b>{' '}
                            </span>
                            <br />
                            Date:{' '}
                            <b>
                                {valuesForm?.seanceDate
                                    ? ' ' + changeToZeroMomentToDate(valuesForm?.seanceDate, 'MMM D, YYYY')
                                    : ''}{' '}
                                {valuesForm?.startTime
                                    ? ' ' + changeToZeroMomentToDate(valuesForm?.startTime, 'LT')
                                    : ''}
                                {' - '}
                                {valuesForm?.endTime ? ' ' + changeToZeroMomentToDate(valuesForm?.endTime, 'LT') : ''}
                            </b>
                        </p>
                    </div>
                    Are you sure you want to save the Session Note?
                </div>
            ),
        },
        PROGRAMBOOK_WAIT: {
            action: () => {
                //dispatch(submit('seance-form'));
                //handleSubmit(currentActionData);
                setCurrentAction('SIGN');
                setCurrentActionData({});
                setPopup(false);
            },
            otherYesBtnText: 'OK',
            otherBtn: false,
            body: (
                <div>
                    {`This case requires data to be entered into the program book. Please enter data for the session before saving the session note.`}
                </div>
            ),
        },
        PRESS_BACK_BTN: {
            action:
                history.length > 1
                    ? () => history.goBack()
                    : () => history.push(Router.generate(routes.PROVIDERS_LIST)),

            body: <div>Are you sure you want to leave this page without saving?</div>,
        },
        LOAD_FILE: {
            action: () => {
                setFiles(fileItD, true);
                setPopup(false);
            },
            body: <div>Are you sure the document you are uploading is a data sheet?</div>,
        },
        SIGN: {
            action: () => {
                dispatch(
                    signSeance(
                        { id: `${initialValues.id}`, seanceFuture },
                        () => {
                            toast.success('Session was signed successfully');

                            history.goBack();
                            setPopup(false);
                        },
                        (errorMessage: string) => {
                            setPopup(false);
                            toast.error(errorMessage);
                        },
                    ),
                );
            },
            body: (
                <div>
                    Are you sure you want to sign this session? <br /> Please review all information is accurate before
                    signing the note.
                </div>
            ),
        },
        COPY: {
            action: () => {
                dispatch(getCopySeance(formValues['copySession']));
                setPopup(false);
            },
            title: 'Copy from session',
            body: (
                <div>
                    <div className={classNames(styles.wrapList)}>
                        {seances.list.map((it: ISeance, k: number) => (
                            <div key={k} className={classNames(styles.item)}>
                                <div className={classNames(styles.left)}>
                                    <FieldInput
                                        name={`copySession`}
                                        value={`${it.id}`}
                                        type="radio"
                                        wrapperConfig={{
                                            classes: {
                                                inputWrapper: 'customCheckbox',
                                            },
                                        }}
                                    />
                                </div>
                                <div className={classNames(styles.sessionPopupItem)}>
                                    <p>
                                        Session Note <b>#{it.id}</b>;
                                        {it.seanceDate ? ' ' + changeToZeroMoment(it.seanceDate, 'MMM DD, YYYY') : ''}
                                        {it.startTime
                                            ? ' ' +
                                              changeToZeroMoment(it.startTime, 'HH:mm') +
                                              '-' +
                                              changeToZeroMoment(it.endTime, 'HH:mm')
                                            : ''}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ),
        },
    };
    const onLoadFile = (itD: any) => {
        setFileItD(itD);
        setCurrentAction('LOAD_FILE');
        setPopup(true);
    };
    const onClickBack = () => {
        if (dirty) {
            setCurrentAction('PRESS_BACK_BTN');
            setPopup(true);
        } else {
            if (history.length > 1) {
                history.goBack();
            } else {
                history.push(Router.generate(routes.PROVIDERS_LIST));
            }
        }
    };
    const signSeanceEvent = () => {
        setCurrentAction('SIGN');
        setPopup(true);
    };
    const onCopy = () => {
        setCurrentAction('COPY');
        getSessionsData();
        setPopup(true);
    };

    const serviceTypeData: any = [];
    const serviceLocationData: any = [];
    serviceTypes.list.forEach((itS) => {
        serviceTypeData.push({ value: itS.id, label: itS.title ? itS.title : itS.cpt });
    });

    serviceLocations.list.forEach((itS) => {
        serviceLocationData.push({ value: itS.id, label: itS.title });
    });
    const MinPerUnit = CaseEnum ? CaseEnum.getEnum('MinPerUnit') : {};
    const minPerUnitData: SelectObject[] = getValFromEnum(MinPerUnit);
    //isHome: false
    //isInPerson: false
    //isTelehealth: null

    const caseCheckBoxs: any = {
        'Home - In person': (
            <div className={'d-flex'}>
                <FieldInput
                    name="isTelehealth"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'Home - Telehealth',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />

                <FieldInput
                    name="isInPerson"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'School - In person',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
                <FieldInput
                    name="isSchool"
                    type="hidden"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        //  label: 'School - Telehealth',
                        classes: {
                            //inputWrapper: 'customCheckbox',
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name="isHome"
                    type="hidden"
                    disabled={isJustProvider && status === 4}
                    value={0}
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
            </div>
        ),

        'School - In person': (
            <div className={'d-flex'}>
                <FieldInput
                    name="isHome"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'Home - In person',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />

                <FieldInput
                    name="isSchool"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'School - Telehealth',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
                <FieldInput
                    name="isTelehealth"
                    type="checkbox"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'Home - Telehealth',
                        classes: {
                            //inputWrapper: 'm-0',
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
                <FieldInput
                    name="isInPerson"
                    type="hidden"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
            </div>
        ),
        'Home - Telehealth': (
            <div className={'d-flex'}>
                <FieldInput
                    name="isHome"
                    disabled={isJustProvider && status === 4}
                    type="checkbox"
                    wrapperConfig={{
                        label: 'Home - In person',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
                <FieldInput
                    name="isSchool"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'School - Telehealth',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />

                <FieldInput
                    name="isInPerson"
                    type="hidden"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        //     label: 'School in Person',
                        classes: {
                            //   inputWrapper: 'customCheckbox',
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name="isTelehealth"
                    type="hidden"
                    disabled={isJustProvider && status === 4}
                    value={0}
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
            </div>
        ),
        'School - Telehealth': (
            <div className={'d-flex'}>
                <FieldInput
                    name="isHome"
                    disabled={isJustProvider && status === 4}
                    type="checkbox"
                    wrapperConfig={{
                        label: 'Home - In person',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />

                <FieldInput
                    name="isTelehealth"
                    type="checkbox"
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        label: 'Home - Telehealth',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
                <FieldInput
                    name="isInPerson"
                    type="hidden"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    wrapperConfig={{
                        //  label: 'School - In person',
                        classes: {
                            //   inputWrapper: 'customCheckbox',
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name="isSchool"
                    value={0}
                    disabled={isJustProvider && status === 4}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
            </div>
        ),
    };
    const today = new Date();

    const [open0, setOpen0] = useState(true);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);
    const [open5, setOpen5] = useState(false);
    const [open6, setOpen6] = useState(false);

    // const programBookAnswers = useSelector((state: StoreState) => state.programBookAnswers);
    // const inProgressAnswers = useSelector((state: StoreState) => state.programBookAnswers.inProgressAnswers);

    const isCannotAddDocument =
        isJustProvider &&
        ((Array.isArray(dataSheetFiles) && !!dataSheetFiles.length) || (Array.isArray(files) && !!files.length));

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <Accordion defaultActiveKey="0">
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => setOpen0(!open0)}>
                        <div className="card-header__title">Service Location</div>
                        <div className="card-header__buttons">
                            <FontAwesomeIcon icon={open0 ? faChevronUp : faChevronDown} className="card-header__icon" />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <div className={classNames(styles.location)}>
                                {caseType && +caseType !== 2 ? (
                                    <div className={classNames(styles.locationHeader)}>
                                        <div className={classNames(styles.locationSubtitle)}>
                                            Your Current Service Location:
                                        </div>
                                        <div
                                            className={classNames(styles.locationTitle)}
                                            style={{
                                                color:
                                                    initialValues.isHome ||
                                                    initialValues.isInPerson ||
                                                    initialValues.isTelehealth ||
                                                    initialValues.isSchool
                                                        ? 'lightgrey'
                                                        : 'black',
                                            }}
                                        >
                                            <b>{initialValues.serviceLocation?.label}</b>
                                        </div>
                                    </div>
                                ) : null}

                                {serviceLocationStatus === 'start' && (
                                    <div>
                                        <span className={classNames(styles.wrapLocation, `mb-3 `)}>
                                            Do you need to change it?
                                        </span>
                                        <div className={classNames(styles.wrapLocation, `mb-3 `, `mt-3`)}>
                                            <b>{initialValues.isHome && 'Home - In person'}</b>{' '}
                                            <b>{initialValues.isInPerson && 'School - In person'}</b>{' '}
                                            <b>{initialValues.isTelehealth && 'Home - Telehealth'}</b>{' '}
                                            <b>{initialValues.isSchool && 'School - Telehealth'}</b>
                                        </div>

                                        <span
                                            className={classNames(styles.colorBtn)}
                                            onClick={() => updateServiceLocationStatus('process')}
                                        >
                                            Change
                                        </span>
                                    </div>
                                )}
                                {serviceLocationStatus === 'process' && (
                                    <div>
                                        <span className={classNames(styles.wrapLocation, `mb-3 `)}>
                                            Do you need to change it?
                                        </span>
                                        <div className={classNames('mt-3')}>
                                            {caseCheckBoxs[initialValues?.serviceLocation?.label]}
                                        </div>
                                        <div className={classNames(styles.actions, 'mt-3')}>
                                            <button
                                                type="button"
                                                className={classNames('btn', 'btn-secondary', 'mr-2')}
                                                onClick={() => updateServiceLocationStatus('start')}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className={classNames('btn', 'btn-success', 'mr-2')}
                                                onClick={() => {
                                                    setLoader(true);
                                                    const isHome = valuesForm.isHome ? !!valuesForm.isHome : false;
                                                    const isInPerson: boolean = valuesForm.isInPerson
                                                        ? !!valuesForm.isInPerson
                                                        : false;
                                                    const isTelehealth = valuesForm.isTelehealth
                                                        ? !!valuesForm.isTelehealth
                                                        : false;
                                                    const isSchool = valuesForm.isSchool
                                                        ? !!valuesForm.isSchool
                                                        : false;

                                                    setTimeout(async () => {
                                                        dispatch(
                                                            updateSeanceLocation(
                                                                {
                                                                    id: initialValues.id,
                                                                    isTelehealth,
                                                                    isInPerson,
                                                                    isHome,
                                                                    isSchool,
                                                                },
                                                                {},
                                                                { resolve: () => false, reject: () => false },
                                                            ),
                                                        );
                                                        updateServiceLocationStatus('end');
                                                    }, 100);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faSave} /> Save
                                            </button>
                                        </div>
                                    </div>
                                )}
                                {serviceLocationStatus === 'end' && (
                                    <div>
                                        <span className={classNames(styles.wrapLocation, `mb-2 `)}>
                                            <b>{valuesForm.isHome && 'Home - In person'}</b>{' '}
                                            <b>{valuesForm.isInPerson && 'School - In person'}</b>{' '}
                                            <b>{valuesForm.isTelehealth && 'Home - Telehealth'}</b>{' '}
                                            <b>{valuesForm.isSchool && 'School - Telehealth'}</b>{' '}
                                        </span>
                                        <span
                                            className={classNames(styles.colorBtn)}
                                            onClick={() => updateServiceLocationStatus('process')}
                                        >
                                            &nbsp; Change
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            {isDatasheetRequired ? (
                <Accordion>
                    <Card className={classNames(styles.cardProgramBook)}>
                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => setOpen1(!open1)}>
                            <div className="card-header__title">Program Book</div>
                            <div className="card-header__buttons">
                                <FontAwesomeIcon
                                    icon={open1 ? faChevronUp : faChevronDown}
                                    className="card-header__icon"
                                />
                            </div>
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div>
                                    <FieldInput
                                        name="eventInfo"
                                        disabled={isJustProvider && status === 4}
                                        onBlur={async () => {
                                            setLoader(false);
                                            const eventInfo = valuesForm?.eventInfo;
                                            await dispatch(
                                                updateSeanceNote(
                                                    {
                                                        eventInfo: eventInfo,
                                                        id: initialValues.id,
                                                    },
                                                    {},
                                                    { resolve: () => false, reject: () => false },
                                                ),
                                            );
                                        }}
                                        validate={validators.eventInfo}
                                        wrapperConfig={{
                                            label: 'Event:',
                                            classes: {
                                                inputWrapper: classNames(styles.inputBlack),
                                            },
                                        }}
                                        placeholder="Please write the event"
                                    />
                                </div>
                                <ProgramBookSession
                                    setLoader={setLoader}
                                    setIsChangedProgramBook={setIsChangedProgramBook}
                                    studentId={initialValues?.student?.id}
                                    programBookAnswers={programBookAnswers}
                                    inProgressAnswers={inProgressAnswers}
                                />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            ) : (
                ''
            )}

            <Accordion>
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => setOpen2(!open2)}>
                        <div className="card-header__title">Session Date/Time</div>
                        <div className="card-header__buttons">
                            <FontAwesomeIcon icon={open2 ? faChevronUp : faChevronDown} className="card-header__icon" />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    <FieldDate
                                        name="seanceDate"
                                        type="text"
                                        date={true}
                                        disabled={(isJustProvider && status === 4) || !!isNotAllowChangeDate}
                                        className="mr-5"
                                        wrapperConfig={{
                                            label: 'Session Date:',
                                        }}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <FieldDate
                                        name="startTime"
                                        disabled={(isJustProvider && status === 4) || !!isNotAllowChangeDate}
                                        type="text"
                                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                                        time={true}
                                        step={15}
                                        formatType={'LT'}
                                        className="mr-5"
                                        wrapperConfig={{
                                            label: 'Start Time:',
                                        }}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <FieldDate
                                        name="endTime"
                                        disabled={(isJustProvider && status === 4) || !!isNotAllowChangeDate}
                                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                                        type="text"
                                        time={true}
                                        formatType={'LT'}
                                        step={15}
                                        className="mr-5"
                                        wrapperConfig={{
                                            label: 'End Time:',
                                        }}
                                    />
                                </div>
                            </div>
                            {/* {isNew ? (
                            <FieldInput
                                name="isWeekly"
                                type="checkbox"
                                wrapperConfig={{
                                    label: 'Weekly',
                                    classes: {
                                        inputWrapper: 'customCheckbox',
                                    },
                                }}
                            />
                        ) : null}*/}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            {caseType && +caseType === 2 ? (
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => setOpen3(!open3)}>
                            <div className="card-header__title">Additional information</div>
                            <div className="card-header__buttons">
                                <FontAwesomeIcon
                                    icon={open3 ? faChevronUp : faChevronDown}
                                    className="card-header__icon"
                                />
                            </div>
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div>
                                    {caseType && +caseType === 3 ? (
                                        <FieldInput
                                            name="seanceInfo"
                                            disabled={isJustProvider && status === 4}
                                            type="text"
                                            wrapperConfig={{
                                                label: 'Student Addition',
                                            }}
                                        />
                                    ) : null}
                                    <FieldDropdown
                                        name="serviceType"
                                        data={serviceTypeData}
                                        disabled={isJustProvider && status === 4}
                                        textField={'label'}
                                        valueField={'value'}
                                        validate={validators.serviceType}
                                        wrapperConfig={{
                                            label: 'Service Type:',
                                        }}
                                    />
                                    <FieldDropdown
                                        name="serviceLocation"
                                        data={serviceLocationData}
                                        disabled={isJustProvider && status === 4}
                                        textField={'label'}
                                        valueField={'value'}
                                        validate={validators.serviceLocation}
                                        wrapperConfig={{
                                            label: 'Service Location:',
                                        }}
                                    />
                                    <FieldDropdown
                                        name="minPerUnit"
                                        data={minPerUnitData}
                                        textField={'label'}
                                        valueField={'value'}
                                        disabled={isJustProvider && status === 4}
                                        validate={validators.minPerUnit}
                                        wrapperConfig={{
                                            label: 'MinPerUnit:',
                                        }}
                                    />
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            ) : null}

            <Accordion defaultActiveKey={isDatasheetRequired ? '4' : '4'}>
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => setOpen4(!open4)}>
                        <div className="card-header__title">Session Notes</div>
                        <div className="card-header__buttons">
                            <FontAwesomeIcon icon={open4 ? faChevronDown : faChevronUp} className="card-header__icon" />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="4">
                        <Card.Body>
                            <button
                                type="button"
                                className={`btn btn-btn-link ${classNames(styles.cardHeaderButton)}`}
                                onClick={() => onCopy()}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </button>
                            <div className={classNames(styles.row)}>
                                <FieldTextArea
                                    name="attendance"
                                    disabled={isJustProvider && status === 4}
                                    onBlur={async () => {
                                        setLoader(false);
                                        const attendance = valuesForm?.attendance;
                                        await dispatch(
                                            updateSeanceNote(
                                                {
                                                    attendance: attendance,
                                                    id: initialValues.id,
                                                },
                                                {},
                                                { resolve: () => false, reject: () => false },
                                            ),
                                        );
                                    }}
                                    validate={validators.attendance}
                                    wrapperConfig={{
                                        label: 'Attendance *:',
                                    }}
                                    placeholder="Please write the text"
                                />
                            </div>

                            <div className={classNames(styles.row)}>
                                <FieldTextArea
                                    name="goals"
                                    disabled={isJustProvider && status === 4}
                                    onBlur={async () => {
                                        setLoader(false);
                                        const goals = valuesForm?.goals;
                                        await dispatch(
                                            updateSeanceNote(
                                                {
                                                    goals: goals,
                                                    id: initialValues.id,
                                                },
                                                {},
                                                { resolve: () => false, reject: () => false },
                                            ),
                                        );
                                    }}
                                    validate={validators.goals}
                                    wrapperConfig={{
                                        label: 'Goals *:',
                                    }}
                                    placeholder="Please write the text"
                                />
                            </div>
                            <div className={classNames(styles.row)}>
                                <FieldTextArea
                                    disabled={isJustProvider && status === 4}
                                    name="problem"
                                    onBlur={async () => {
                                        setLoader(false);
                                        const problem = valuesForm?.problem;
                                        dispatch(
                                            updateSeanceNote(
                                                {
                                                    problem: problem,
                                                    id: initialValues.id,
                                                },
                                                {},
                                                { resolve: () => false, reject: () => false },
                                            ),
                                        );
                                    }}
                                    validate={validators.problem}
                                    wrapperConfig={{
                                        label: 'Challenging Behavior *:',
                                    }}
                                    placeholder="Please write the text"
                                />
                            </div>
                            <div className={classNames(styles.row)}>
                                <FieldTextArea
                                    name="plan"
                                    disabled={isJustProvider && status === 4}
                                    onBlur={() => {
                                        setLoader(false);
                                        const plan = valuesForm?.plan;
                                        setTimeout(async () => {
                                            dispatch(
                                                updateSeanceNote(
                                                    {
                                                        plan: plan,
                                                        id: initialValues.id,
                                                    },
                                                    {},
                                                    { resolve: () => false, reject: () => false },
                                                ),
                                            );
                                        }, 300);
                                    }}
                                    validate={validators.plan}
                                    wrapperConfig={{
                                        label: 'Plan *:',
                                    }}
                                    placeholder="Please write the text"
                                />
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            <Accordion>
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => setOpen5(!open5)}>
                        <div className="card-header__title">Documents</div>
                        <div className="card-header__buttons">
                            <FontAwesomeIcon icon={open5 ? faChevronUp : faChevronDown} className="card-header__icon" />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="5">
                        <Card.Body>
                            <div className="mb-3">
                                <div className={classNames(styles.wrapDoc, 'position-relative')}>
                                    {miniLoaderFor['FILE'] ? <Loader noFull={true} /> : null}
                                    {isDatasheetRequired ? (
                                        <div>
                                            <b>Data Sheet</b>
                                            <DropZoneField
                                                download={true}
                                                files={dataSheetFiles}
                                                // setFiles={(itD: any) => setFiles(itD, true)}
                                                setFiles={(itD: any) => onLoadFile(itD)}
                                                removeFile={(id: string | number) => removeFile(id)}
                                                fieldDZInformation={false}
                                                typeViewFiles={'forService'}
                                                disabled={isCannotAddDocument}
                                            />
                                        </div>
                                    ) : null}
                                    <div>Other documents:</div>
                                    <DropZoneField
                                        download={true}
                                        files={files}
                                        disabled={isCannotAddDocument}
                                        setFiles={(itD: any) => setFiles(itD, false)}
                                        removeFile={(id: string | number) => removeFile(id)}
                                        typeDropZone={'main'}
                                        fieldDZInformation={false}
                                        typeViewFiles={'forService'}
                                    />
                                </div>
                                <div className={classNames(styles.information, 'mb-2')}>
                                    If the file(s) has(ve) been successfully added, you don`t need to save or sign the
                                    session again. It`s attached automatically
                                </div>
                                <div className={classNames(styles.fileDescription)}>
                                    <b>Types:</b> pdf, images, csv, excel, txt, doc | <b>Max Size:</b> 30Mb
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            <Accordion>
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="6" onClick={() => setOpen6(!open6)}>
                        <div className="card-header__title">Settings</div>
                        <div className="card-header__buttons">
                            <FontAwesomeIcon icon={open6 ? faChevronUp : faChevronDown} className="card-header__icon" />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="6">
                        <Card.Body>
                            <div className="mb-3">
                                <button
                                    type="button"
                                    className={classNames(styles.deleteButton, 'btn')}
                                    disabled={(isJustProvider && status === 4) || !!isNotAllowChangeDate}
                                    onClick={() => setDeleteModal(`${initialValues?.id}`)}
                                >
                                    <FontAwesomeIcon icon={faTrash} /> Delete this session
                                </button>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            <div className={classNames(styles.actions)}>
                {history.length > 1 && (
                    <button type="button" className={classNames('btn', 'btn-secondary', 'mr-2')} onClick={onClickBack}>
                        <FontAwesomeIcon icon={faArrowLeft} /> Back
                    </button>
                )}
                {isDatasheetRequired ? (
                    <button
                        type="button"
                        className={classNames('btn', 'btn-success', 'mr-2')}
                        disabled={!dirty || submitting}
                        onClick={(e) => {
                            let hasAnswerPB = false;
                            if (programBookAnswers?.data?.list?.length) {
                                programBookAnswers?.data?.list?.some((item: any) => {
                                    hasAnswerPB = !item.isSkip;
                                    if (hasAnswerPB) {
                                        return true;
                                    }
                                });
                            }
                            if (hasAnswerPB || isChangedProgramBook) {
                                setCurrentAction('PROGRAMBOOK_DONE');
                                // setCurrentActionData({});
                                setPopup(true);
                            } else {
                                setCurrentAction('PROGRAMBOOK_WAIT');
                                setPopup(true);
                            }
                            setCurrentActionData(e);
                            setPopup(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Save'}
                    </button>
                ) : (
                    <button
                        type="button"
                        className={classNames('btn', 'btn-success', 'mr-2')}
                        disabled={!dirty || submitting}
                        onClick={(e) => {
                            e.preventDefault();
                            setCurrentActionData(e);
                            setCurrentAction('PROGRAMBOOK_DONE');
                            setPopup(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Save'}
                    </button>
                )}
                <button
                    type="button"
                    className={classNames('btn', 'btn-info', 'mr-2')}
                    disabled={(dirty && !submitting) || (isJustProvider && status === 4)}
                    onClick={() => signSeanceEvent()}
                >
                    <FontAwesomeIcon icon={faFileSignature} /> Sign
                </button>
            </div>

            <ModalComponent
                modal={popup}
                setModal={setPopup}
                dataBody={entityModal[currentAction]?.body}
                action={entityModal[currentAction]?.action}
                title={entityModal[currentAction]?.title}
                otherBtn={entityModal[currentAction]?.otherBtn}
                otherYesBtnText={entityModal[currentAction]?.otherYesBtnText}
            />
            <ModalComponent
                modal={backModal}
                setModal={setBackModal}
                dataBody={entityModal[currentAction]?.body}
                action={entityModal[currentAction]?.action}
            />

            <ModalComponent
                modal={isDropZoneLoad}
                setModal={setIsDropZoneLoad}
                dataBody={entityModal[currentAction]?.body}
                action={entityModal[currentAction]?.action}
                otherCancelBtnText={'No'}
            />
            <ModalDelete id={deleteModal} redirectId={+idProvider} setModal={setDeleteModal} />
        </form>
    );
};

export default reduxForm<SeanceFormData, SeanceFormProps>({
    form: 'seance-form',
    enableReinitialize: true,
    onSubmit: async (data: SeanceFormData, dispatch: Dispatch<any>, props: SeanceFormProps) => {
        props.setLoader(true);

        const isHome = data.isHome ? !!data.isHome : false;
        const isInPerson: boolean = data.isInPerson ? !!data.isInPerson : false;
        const isTelehealth = data.isTelehealth ? !!data.isTelehealth : false;
        const isSchool = data.isSchool ? !!data.isSchool : false;

        let isWeekly = {};
        if (
            typeof data.endTime === 'string' ||
            typeof data.startTime === 'string' ||
            typeof data.seanceDate === 'string'
        ) {
            isWeekly = { isWeekly: false };
        }

        if (props.isDatasheetRequired) {
            //dispatch(submit('program-book'));
        }

        await asyncPersistSeance(
            {
                ...data,
                isTelehealth,
                isInPerson,
                isHome,
                isSchool,
                ...isWeekly,
                columnForm: true,
                detailPage: true,
            },
            { files: props.files, signDoc: props.signDoc },
            dispatch,
        );
        // }
    },
    onSubmitSuccess(result: any, dispatch: Dispatch<any>, props: DecoratedFormProps<SeanceFormData, SeanceFormProps>) {
        //   const isNew = !props.initialValues || !props.initialValues.id;
        /*  history.push(
            Router.generate(routes.PROVIDER_DETAIL, {
                tab: `${props.initialValues?.occasion}`,
                id: props.idProvider,
                subId: props.initialValues?.id ? `${props.initialValues.id}` : '',
                //subId: props.initialValues?.occasion,
            }),
        );*/
        //toast.success(`Session was successfully updated.`);
    },
    onSubmitFail(errors: { _error: string }) {
        if (errors?._error) {
            toast.error(errors._error);
        }
    },
})(SeanceForm);
